import { render, staticRenderFns } from "./SkillRenameDialog.vue?vue&type=template&id=2fa656e7&"
import script from "./SkillRenameDialog.vue?vue&type=script&lang=js&"
export * from "./SkillRenameDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports